import { catalogSearchReset } from "@/features/sparxsEditor/store/slices/catalog/catalogSearchSlice";
import { getAppStore, getPersistor } from "@/store/app/appStoreInstance";
import { setConsoleApiNonSettingsAccessAllowed } from "@/services/consoleApiLoaders";
import { clearCurrentFinancialInstitution } from "@/lib/session/currentFinancialInstitutionStorage";
import {
  UNOWNED_CACHE_OWNER,
  saveCacheOwner,
} from "@/lib/session/cacheOwnerStorage";

/** Explicit sign-out: the persisted caches are wiped so the next user starts clean. */
export const onClientSessionEnd = async (): Promise<void> => {
  setConsoleApiNonSettingsAccessAllowed(false);
  clearCurrentFinancialInstitution();
  getAppStore().dispatch(catalogSearchReset());
  await getPersistor().purge();
  saveCacheOwner(UNOWNED_CACHE_OWNER);
};

/**
 * Involuntary session end (the token can no longer be renewed): the same user usually
 * signs straight back in, so the persisted caches stay. Whoever signs in next claims
 * them or purges them (see `claimPersistedCachesForUser`).
 */
export const onClientSessionInterrupted = (): void => {
  setConsoleApiNonSettingsAccessAllowed(false);
};
